<template>
  <div class="loader">
    <i class="fa fa-spinner fa-pulse fa-fw loader__icon"/>
  </div>
</template>

<script>
  export default {
    name: "GcLoader"
  }
</script>

<style>
  .balance-checker .loader {
    font-size: 16px;
    display: inline-block;
  }
</style>
